import { useState, Fragment, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Sidebar from "../../components/Sidebar";
import PublishIcon from "@mui/icons-material/Publish";
import Box from "@mui/material/Box";
import { API_URL, MAIN_TITLE, alertMessage } from "../../actions/auth";
import Checkbox from "@mui/material/Checkbox";
import CheckIcon from "@mui/icons-material/Check";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import CloseIcon from "@mui/icons-material/Close";
import { useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Fab from "@mui/material/Fab";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import { DatePicker } from "@mui/x-date-pickers";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import moment from "moment";
import IconButton from "@mui/material/IconButton";
import { themeStyle } from "../../components/Components";
import ButtonBase from "@mui/material/ButtonBase";
import DeleteIcon from "@mui/icons-material/Delete";
import FileOpenIcon from "@mui/icons-material/FileOpen";

const colorList = ["#dfffdbff", "#c0e9ffff", "#fdcacaff"];
const colorList2 = ["#31a354", themeStyle.primaryColor, "#e6550d"];
const colorList3 = ["#cbf5afff", "#9ecae1", "#ffb5b5ff"];

function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

function LeaveRequestsTeacher() {
  const dispatch = useDispatch();
  function createAlert(type, title, message) {
    dispatch(alertMessage(type, title, message));
  }
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const state = useSelector((state) => state);
  const [open, setOpen] = useState(false);
  const [leaveRequestList, setLeaveRequestList] = useState([]);
  const [id, setId] = useState("");
  const [classList, setClassList] = useState([]);
  const [classs, setClass] = useState("");
  const [division, setDivision] = useState("");
  const [semester, setSemester] = useState("");

  const handlePageSelect = (event) => {
    setSeeLeaves(false);
    setSelectedPage(event.currentTarget.value);
    getStudentLeaves(classs, division);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const [open1, setOpen1] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedFile, setSelectedFile] = useState("");
  const [open2, setOpen2] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [toggleDrawer, setToggleDrawer] = useState(false);
  const [isReady, setIsReady] = useState(false);

  const [selectedPage, setSelectedPage] = useState(
    params.get("tab") ? params.get("tab") : "APPLY",
  );

  function onFileChange(event) {
    // Update the state
    setSelectedFile(event.target.files[0]);

    setOpen3(true);
  }

  function getSemesterList() {
    var semesters = Object.keys(classList).map((semester, index) => (
      <MenuItem value={semester}>{semester}</MenuItem>
    ));
    return semesters;
  }

  function getClassList() {
    var classes = Object.keys(classList[semester]).map((classs, index) => (
      <MenuItem value={classs}>{classs}</MenuItem>
    ));
    return classes;
  }

  function getDivisionList() {
    var classes = Object.keys(classList[semester][classs]).map(
      (division, index) => <MenuItem value={division}>{division}</MenuItem>,
    );
    return classes;
  }

  function handleSemesterChange(e) {
    setSemester(e.target.value);
    setClass(Object.keys(classList[e.target.value])[0]);
    setDivision(
      Object.keys(
        classList[e.target.value][Object.keys(classList[e.target.value])[0]],
      )[0],
    );
    getStudentLeaves(
      Object.keys(classList[e.target.value])[0],
      Object.keys(
        classList[e.target.value][Object.keys(classList[e.target.value])[0]],
      )[0],
    );
  }

  function handleClassChange(e) {
    setClass(e.target.value);
    setDivision(
      Object.keys(
        classList[semester][Object.keys(classList[e.target.value])[0]],
      )[0],
    );
    setIsLoading(true);
    getStudentLeaves(
      e.target.value,
      Object.keys(
        classList[semester][Object.keys(classList[e.target.value])[0]],
      )[0],
    );
  }

  function handleDivisionChange(e) {
    setDivision(e.target.value);
    setIsLoading(true);
    getStudentLeaves(classs, e.target.value);
  }

  function onFileUpload() {
    setIsSubmitting(true);
    // Create an object of formData
    const formData = new FormData();

    // Update the formData object
    formData.append("file", selectedFile, selectedFile.name);

    // Details of the uploaded file
    console.log(selectedFile);

    // Request made to the backend api
    // Send formData object

    const config = {
      headers: {
        Authorization: state.auth.token,

        // "Content-Type": "application/json",
      },
    };

    formData.append("name", name);
    formData.append("user_id", state.auth.user.user_id);
    formData.append("institution_id", state.auth.user.institution_id);
    formData.append("leave_subject", leaveSubject);
    formData.append("leave_description", leaveDescription);

    formData.append("current_year", state.auth.current_year);

    formData.append("id", makeid(5));
    formData.append(
      "completion_date",
      moment(selectedDate).format("DD-MM-YYYY"),
    );

    formData.append("date", moment(selectedDate).format("DD-MM-YYYY"));

    axios
      .post(API_URL + "/add_leave_request", formData, config)
      .then(() => {
        getData();
        setIsSubmitting(false);
        setToggleDrawer(false);
        setOpen3(false);
        createAlert("SUCCESS", "Success.", "Leave request submitted.");
      })
      .catch((err) => {
        createAlert("ERROR", "Error", "An error occured.");
      });

    setOpen(false);
    document.getElementById("contained-button-file").value = "";
  }

  function fileData() {
    if (selectedFile) {
      return (
        <div>
          <div
            style={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <IconButton size="small">
              <CloseIcon
                onClick={() => setOpen3(false)}
                style={{ color: themeStyle.primaryColor }}
              />
            </IconButton>
          </div>
          <h2>File Details:</h2>
          <p>File Name: {selectedFile.name}</p>
          <p>File Type: {selectedFile.type}</p>

          <br></br>
          <br></br>
          {selectedFile.size > 25 * 1024 * 1024 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  createAlert(
                    "ERROR",
                    "File too big.",
                    "File size should be less than 25 MB.",
                  );
                  setOpen3(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD DOCUMENTS
              </Button>
            </div>
          ) : selectedFile.name.length >= 50 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  createAlert(
                    "ERROR",
                    "File name to obig.",
                    "File size should be less than 50 characters.",
                  );
                  setOpen3(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD DOCUMENTS
              </Button>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                onClick={() => onFileUpload()}
                style={{ backgroundColor: themeStyle.primaryColor }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD DOCUMENTS
              </Button>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div>
          <h4>Choose before Pressing the Upload button</h4>
        </div>
      );
    }
  }

  function deleteItem() {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };
    body["user_id"] = state.auth.user.user_id;
    body["id"] = id;
    body = JSON.stringify(body);
    axios.post(API_URL + "/delete_leave_request", body, config).then((res) => {
      getData();
      setOpen2(false);
    });
  }

  const [leaveSubject, setLeaveSubject] = useState("");
  const [leaveDescription, setLeaveDescription] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const [leaveId, setLeaveId] = useState("");
  const [userId, setUserId] = useState("");
  const [seeLeaves, setSeeLeaves] = useState("");
  const [leaveDate, setLeaveDate] = useState("");

  const [studentLeaveRequests, setStudentLeaveRequests] = useState([]);
  const [ogLeaves, setOGLeaves] = useState("");
  const [classListInstitution, setClassListInstitution] = useState({});
  const [noClasses, setNoClasses] = useState(false);
  const [selectedApprove, setSelectedApprove] = useState(false);
  const [name, setName] = useState("");
  const [type, setType] = useState("ALL");

  function getStudentLeaves(cla, div) {
    setIsLoading(true);
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };
    body["institution_id"] = state.auth.user.institution_id;
    body["user_id"] = state.auth.user.user_id;
    body["class_id"] = cla;
    body["division"] = div;
    body = JSON.stringify(body);
    console.log(body);
    axios
      .post(API_URL + "/get_leave_requests_teacher", body, config)
      .then((res) => {
        setStudentLeaveRequests(res.data);
        setOGLeaves(JSON.stringify(res.data));
        setIsLoading(false);
      });
  }

  function getData() {
    setIsLoading(true);
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };
    body["institution_id"] = state.auth.user.institution_id;
    body["user_id"] = state.auth.user.user_id;

    body = JSON.stringify(body);
    axios.post(API_URL + "/get_leave_requests", body, config).then((res) => {
      setLeaveRequestList(res.data);
      setIsLoading(false);
    });
  }

  useEffect(() => {
    if (state.auth.isLoading) {
      dispatch({ type: "ENTRY_PAGE", payload: window.location.pathname });
      navigate("/", { replace: true });
    } else {
      getData();
      var classListTemp = JSON.parse(state.auth.user.class_id_list);
      if (Object.keys(classListTemp).length == 0) {
        setNoClasses(true);
        setIsLoading(false);
        setIsReady(true);
      } else {
        setClassList(classListTemp);
        setSemester(Object.keys(classListTemp)[0]);
        setClass(Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0]);
        setDivision(
          Object.keys(
            classListTemp[Object.keys(classListTemp)[0]][
              Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0]
            ],
          )[0],
        );
        setIsReady(true);
        getStudentLeaves(classs, division);
      }
    }
  }, []);

  if (state.auth.refresh == "REFRESH_DATA") {
    getData();
    getStudentLeaves(classs, division);
    dispatch({ type: "REFRESH_DATA", payload: null });
  }

  function handleApprovalChange(approval) {
    setType(approval);
    if (approval != "ALL") {
      var tempList = [];
      var ogs = JSON.parse(ogLeaves);
      for (var i = 0; i < ogs.length; i++) {
        if (ogs[i]["status"] == approval) {
          tempList.push(ogs[i]);
        }
      }
      setStudentLeaveRequests(tempList);
    } else {
      setStudentLeaveRequests(JSON.parse(ogLeaves));
    }
  }

  function approveLeave(approval) {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };
    body["leave_request_id"] = leaveId;
    body["leave_date"] = leaveDate;
    body["user_id"] = userId;
    body["teacher"] = state.auth.user.user_id;
    body["approval"] = approval ? "APPROVED" : "REJECTED";
    body["date"] = moment().format("DD-MM-YYYY");
    body = JSON.stringify(body);

    axios
      .post(API_URL + "/approve_leave_requests", body, config)
      .then((res) => {
        getStudentLeaves(classs, division);
        setOpen(false);
        createAlert(
          "SUCCESS",
          "Success.",
          approval ? "Leave APPROVED" : "Leave REJECTED",
        );
      })
      .catch((err) => {
        createAlert("ERROR", "Error", "An error occured.");
      });
  }

  function getPageContent() {
    if (selectedPage == "APPLY") {
      return (
        <div style={{ marginTop: "98px" }}>
          <Grid container spacing={3} style={{ marginTop: "-50px" }}>
            <Grid item md={8}>
              {leaveRequestList.length == 0 ? (
                <div
                  style={{
                    marginTop: "200px",
                    height: "100px",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <Fab
                      size="large"
                      style={{
                        border: "3px solid #aaa",
                        boxShadow: "none",
                        backgroundColor: "transparent",
                      }}
                      aria-label="add"
                    >
                      <PriorityHighIcon
                        style={{
                          color: "grey",
                        }}
                      />
                    </Fab>
                    <br />
                    <h4 style={{ color: "grey" }}>No Leave requests.</h4>
                  </div>
                </div>
              ) : (
                ""
              )}
              {leaveRequestList.map((leave, index) => (
                <Box
                  p={2}
                  style={{
                    height: "80px",
                    marginBottom: "15px",
                    borderRadius: "15px",
                    border:
                      leave["status"] == "PENDING"
                        ? "1.5px solid" + themeStyle.primaryColor
                        : "none",
                    backgroundColor:
                      leave["status"] == "PENDING"
                        ? "white"
                        : leave["status"] == "APPROVED"
                          ? colorList[0]
                          : colorList[2],
                    color: "black",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItemsL: "center",
                    }}
                  >
                    <div style={{ width: "90%" }}>
                      <div
                        style={{
                          margin: "-25px 0px 0px -3px",
                        }}
                      >
                        <h3
                          style={{
                            lineHeight: "20px",
                            color:
                              leave["status"] == "PENDING"
                                ? colorList2[1]
                                : leave["status"] == "APPROVED"
                                  ? colorList2[0]
                                  : colorList2[2],
                          }}
                        >
                          {leave["subject"]}
                        </h3>
                      </div>
                      <div
                        style={{
                          margin: "-15px 0px 0px -3px",
                          fontSize: "14px",
                        }}
                      >
                        {moment(leave["date"], "DD-MM-YYYY").format(
                          "Do MMMM, YYYY",
                        )}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        {leave["status"] == "PENDING" ? (
                          <ButtonBase
                            style={{
                              cursor: "pointer",
                              marginLeft: "-10px",
                              display: "flex",
                              backgroundColor: "#ff3333",
                              borderRadius: "6px",
                              padding: "3px",
                              alignItems: "center",
                              justifyContent: "space-between",
                              position: "relative",
                              bottom: "62px",
                              height: "25px",
                              width: "25px",
                              right: "-105px",
                            }}
                            onClick={() => {
                              setId(leave["id"]);
                              setOpen2(true);
                            }}
                          >
                            <DeleteIcon
                              style={{ color: "white", fontSize: "18px" }}
                            />
                          </ButtonBase>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <div
                      style={{
                        width: "100px",
                        display: "flex",
                        justifyContent: "center",
                        marginTop:
                          leave["status"] == "PENDING" ? "-12px" : "-5px",
                        marginRight: "-15px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <Box
                          textAlign="center"
                          p={1}
                          style={{
                            height: "35px",
                            width: "35px",
                            borderRadius: "60px",
                            backgroundColor:
                              leave["status"] == "PENDING"
                                ? colorList2[1]
                                : leave["status"] == "APPROVED"
                                  ? colorList2[0]
                                  : colorList2[2],
                            color: "white",
                          }}
                        >
                          {leave["status"] == "PENDING" ? (
                            <PriorityHighIcon
                              style={{
                                fontSize: "30px",
                                margin: "-5px 0px 0px -5.5px",
                              }}
                            />
                          ) : leave["status"] == "APPROVED" ? (
                            <CheckIcon
                              style={{
                                fontSize: "30px",
                                margin: "-5px 0px 0px -5.5px",
                              }}
                            />
                          ) : (
                            <CloseIcon
                              style={{
                                fontSize: "30px",
                                margin: "-5px 0px 0px -5.5px",
                              }}
                            />
                          )}
                        </Box>
                        <b
                          style={{
                            marginTop: "5px",
                            color:
                              leave["status"] == "PENDING"
                                ? colorList2[1]
                                : leave["status"] == "APPROVED"
                                  ? colorList2[0]
                                  : colorList2[2],
                          }}
                        >
                          <span
                            style={{
                              fontWeight: "lighter",
                            }}
                          >
                            {leave["status"]}
                          </span>
                        </b>
                      </div>
                    </div>
                  </div>
                </Box>
              ))}
            </Grid>
            <Grid item md={4}>
              <div style={{ marginTop: "-25px" }}>
                <h3>Apply for Leave</h3>
              </div>
              <div
                style={{
                  color: themeStyle.primaryColor,

                  fontSize: "14px",
                  marginTop: "-10px",
                }}
              >
                Choose a date
              </div>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="dd-MM-yyyy"
                  value={selectedDate}
                  onChange={handleDateChange}
                  renderInput={(params) => (
                    <TextField
                      style={{
                        marginTop: "2px",
                        marginBottom: "5px",
                      }}
                      size="small"
                      fullWidth
                      {...params}
                    />
                  )}
                />
              </LocalizationProvider>
              <br></br>
              <span
                style={{
                  color: themeStyle.primaryColor,

                  fontSize: "14px",
                }}
              >
                Leave Subject
              </span>
              <TextField
                value={leaveSubject}
                style={{ marginTop: "2px", marginBottom: "15px" }}
                onChange={(e) => setLeaveSubject(e.target.value)}
                fullWidth
                placeholder="Reason for leave"
                variant="outlined"
                size="small"
              />
              <span
                style={{
                  color: themeStyle.primaryColor,

                  fontSize: "14px",
                }}
              >
                Leave Description
              </span>
              <TextField
                multiline={true}
                rows={4}
                value={leaveDescription}
                style={{ marginTop: "2px" }}
                onChange={(e) => setLeaveDescription(e.target.value)}
                fullWidth
                placeholder="Reason for leave"
                variant="outlined"
                size="small"
              />
              <br></br>
              <br></br>
              <div style={{}}>
                <label
                  style={{ width: "100%" }}
                  htmlFor="contained-button-file"
                >
                  <input
                    style={{ display: "none" }}
                    id="contained-button-file"
                    type="file"
                    onChange={(e) => onFileChange(e)}
                  />

                  <Button
                    style={{
                      width: "100%",
                      fontSize: "15px",
                      height: "35px",
                      marginTop: "-1px",
                      backgroundColor: themeStyle.primaryColor,
                    }}
                    variant="contained"
                    component="span"
                  >
                    <h4>Upload Request Application</h4>
                  </Button>
                </label>
                <Button
                  style={{
                    width: "100%",
                    fontSize: "15px",
                    height: "35px",
                    marginTop: "15px",
                    backgroundColor: themeStyle.primaryColor,
                  }}
                  onClick={() => {
                    if (
                      leaveSubject.length == 0 ||
                      leaveDescription.length == 0
                    ) {
                      createAlert(
                        "ERROR",
                        "Error",
                        "Please add reason for leave.",
                      );
                    } else {
                      setIsSubmitting(true);
                      // Create an object of formData
                      const formData = new FormData();

                      // Update the formData object

                      // Details of the uploaded file

                      // Request made to the backend api
                      // Send formData object

                      const config = {
                        headers: {
                          Authorization: state.auth.token,

                          // "Content-Type": "application/json",
                        },
                      };

                      formData.append("user_id", state.auth.user.user_id);
                      formData.append("id", makeid(5));

                      formData.append("leave_subject", leaveSubject);
                      formData.append("leave_description", leaveDescription);
                      formData.append(
                        "date",
                        moment(selectedDate).format("DD-MM-YYYY"),
                      );

                      axios
                        .post(API_URL + "/add_leave_request", formData, config)
                        .then(() => {
                          getData();
                          setIsSubmitting(false);
                          setToggleDrawer(false);
                          setOpen3(false);
                          createAlert(
                            "SUCCESS",
                            "Success.",
                            "Leave request submitted.",
                          );
                        })
                        .catch((err) => {
                          createAlert("ERROR", "Error", "An error occured.");
                        });
                    }
                  }}
                  variant="contained"
                  component="span"
                >
                  <h4>Submit without application</h4>
                </Button>
              </div>
              <br></br>
              {isSubmitting ? (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress />
                </div>
              ) : (
                ""
              )}
            </Grid>
          </Grid>
        </div>
      );
    } else {
      return (
        <Fragment>
          <Grid container spacing={1}>
            <Grid item xs={9}>
              <Grid container spacing={1.5}>
                {studentLeaveRequests.length == 0 ? (
                  <div
                    style={{
                      marginTop: "200px",
                      height: "100px",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <div style={{ textAlign: "center" }}>
                      <Fab
                        size="large"
                        style={{
                          border: "3px solid #aaa",
                          boxShadow: "none",
                          backgroundColor: "transparent",
                        }}
                        aria-label="add"
                      >
                        <PriorityHighIcon
                          style={{
                            color: "grey",
                          }}
                        />
                      </Fab>
                      <br />
                      <h4 style={{ color: "grey" }}>
                        No student leave requests.
                      </h4>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {studentLeaveRequests.map((leave, index) => (
                  <Grid item md={3}>
                    <Box
                      style={{
                        minHeight: "100%",
                        borderRadius: "6px",
                        border: "1.3px solid " + themeStyle.primaryColorLight,
                        backgroundColor: "white",
                        boxShadow: "none",
                        padding: "15px",
                      }}
                    >
                      <div
                        style={{
                          margin: "-5px 0px 0px 0px",
                          fontSize: "18px",
                          color: themeStyle.secondaryColor,
                        }}
                      >
                        {leave["name"]}
                      </div>
                      <div style={{ fontSize: "14px" }}>{leave["subject"]}</div>
                      <div
                        style={{
                          marginTop: "10px",
                          color: themeStyle.primaryColor,
                        }}
                      >
                        {leave["class"]}
                      </div>
                      <div style={{ marginTop: "-5px" }}>
                        {" "}
                        {moment(leave["date"], "DD-MM-YYYY").format(
                          "Do MMMM, YYYY",
                        )}
                      </div>

                      <div style={{ margin: "0px 0px 0px 0px" }}>
                        {leave["description"]}
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginBottom: "-5px",
                          marginRight: "-5px",
                        }}
                      >
                        {leave["documents"].length != 0 ? (
                          <Fab
                            size="small"
                            style={{
                              transform: "scale(0.8)",
                              boxShadow: "none",
                              backgroundColor: themeStyle.primaryColor,
                            }}
                            onClick={() => {
                              window.open(leave["documents"], "_blank");
                            }}
                            aria-label="add"
                          >
                            <FileOpenIcon
                              style={{
                                color: "white",
                              }}
                            />
                          </Fab>
                        ) : (
                          ""
                        )}
                        <Fab
                          size="small"
                          style={{
                            transform: "scale(0.8)",
                            boxShadow: "none",
                            backgroundColor:
                              leave["status"] == "PENDING"
                                ? themeStyle.primaryColor
                                : leave["status"] == "APPROVED"
                                  ? colorList2[0]
                                  : colorList2[2],
                          }}
                          onClick={() => {
                            setLeaveId(leave["id"]);
                            setUserId(leave["user_id"]);
                            setLeaveDate(leave["date"]);
                            setOpen(true);
                          }}
                          aria-label="add"
                        >
                          {leave["status"] == "PENDING" ? (
                            <PriorityHighIcon
                              style={{
                                fontSize: "30px",
                                color: "white",
                              }}
                            />
                          ) : leave["status"] == "APPROVED" ? (
                            <CheckIcon
                              style={{
                                fontSize: "30px",
                                color: "white",
                              }}
                            />
                          ) : (
                            <CloseIcon
                              style={{
                                fontSize: "30px",
                                color: "white",
                              }}
                            />
                          )}
                        </Fab>
                      </div>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid item md={3} style={{ marginTop: "-8px" }}>
              {noClasses ? (
                <div
                  style={{
                    marginTop: "200px",
                    height: "100px",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <Fab
                      size="large"
                      style={{
                        border: "3px solid #aaa",
                        boxShadow: "none",
                        backgroundColor: "transparent",
                      }}
                      aria-label="add"
                    >
                      <PriorityHighIcon
                        style={{
                          color: "grey",
                        }}
                      />
                    </Fab>
                    <br />
                    <h4 style={{ color: "grey" }}>
                      No classes or subjects appointed.
                    </h4>
                  </div>
                </div>
              ) : (
                <Fragment>
                  {state.auth.classType == "SEMESTERS" ? (
                    <span
                      style={{
                        color: themeStyle.primaryColor,

                        fontSize: "14px",
                      }}
                    >
                      Semester
                    </span>
                  ) : (
                    ""
                  )}
                  {state.auth.classType == "SEMESTERS" ? (
                    <Select
                      value={semester}
                      onChange={(e) => handleSemesterChange(e)}
                      style={{
                        marginTop: "2px",
                        height: "40px",
                        marginBottom: "5px",
                      }}
                      fullWidth
                      variant={"outlined"}
                    >
                      {getSemesterList()}
                    </Select>
                  ) : (
                    ""
                  )}
                  <span
                    style={{
                      color: themeStyle.primaryColor,

                      fontSize: "14px",
                    }}
                  >
                    Class
                  </span>
                  <Select
                    value={classs}
                    onChange={(e) => handleClassChange(e)}
                    style={{
                      marginTop: "2px",
                      height: "40px",
                      marginBottom: "5px",
                    }}
                    fullWidth
                    variant={"outlined"}
                  >
                    {getClassList()}
                  </Select>
                  <span
                    style={{
                      color: themeStyle.primaryColor,

                      fontSize: "14px",
                    }}
                  >
                    Division
                  </span>
                  <Select
                    value={division}
                    onChange={(e) => handleDivisionChange(e)}
                    style={{
                      marginTop: "2px",
                      height: "40px",
                      marginBottom: "5px",
                    }}
                    fullWidth
                    variant={"outlined"}
                  >
                    {getDivisionList()}
                  </Select>
                  <span
                    style={{
                      color: themeStyle.primaryColor,

                      fontSize: "14px",
                    }}
                  >
                    Approval
                  </span>
                  <Select
                    value={type}
                    onChange={(e) => handleApprovalChange(e.target.value)}
                    style={{
                      marginTop: "2px",
                      height: "40px",
                      marginBottom: "5px",
                    }}
                    fullWidth
                    variant={"outlined"}
                  >
                    <MenuItem value={"ALL"}>ALL</MenuItem>
                    <MenuItem value={"PENDING"}>PENDING</MenuItem>
                    <MenuItem value={"APPROVED"}>APPROVED</MenuItem>
                    <MenuItem value={"REJECTED"}>REJECTED</MenuItem>
                  </Select>
                </Fragment>
              )}
            </Grid>
          </Grid>
        </Fragment>
      );
    }
  }

  if (!state.auth.isLoading) {
    if (state.auth.isAuthenticated) {
      if (state.auth.user.is_teacher) {
        if (isLoading || !isReady) {
          return (
            <Fragment>
              <Sidebar />
              <div
                style={{
                  borderRadius: "15px",
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  backgroundColor: "white",
                  marginTop: "46vh",
                }}
              >
                <CircularProgress />
              </div>
            </Fragment>
          );
        } else {
          return (
            <Fragment>
              <Sidebar
                tabs={
                  <Grid container spacing={1.5} justifyContent="flex-end">
                    <Grid item md={4}>
                      {selectedPage == "APPLY" ? (
                        <Button
                          fullWidth
                          value="APPLY"
                          onClick={handlePageSelect}
                          p={2}
                          style={{
                            backgroundColor: themeStyle.primaryColor,
                            color: "white",
                            height: "30px",
                          }}
                          borderRadius={6}
                        >
                          <h3
                            style={{
                              marginTop: "16px",
                              fontSize: "15px",
                            }}
                          >
                            APPLY
                          </h3>
                        </Button>
                      ) : (
                        <Button
                          fullWidth
                          value="APPLY"
                          onClick={handlePageSelect}
                          p={2}
                          style={{
                            backgroundColor: themeStyle.primaryColorLight,
                            color: "white",
                            height: "30px",
                          }}
                          borderRadius={6}
                        >
                          <h3
                            style={{
                              marginTop: "16px",
                              fontSize: "15px",
                              color: themeStyle.secondaryColor,
                            }}
                          >
                            APPLY
                          </h3>
                        </Button>
                      )}
                    </Grid>
                    <Grid item md={4}>
                      {selectedPage == "LEAVEREQUESTS" ? (
                        <Button
                          fullWidth
                          value="LEAVEREQUESTS"
                          onClick={handlePageSelect}
                          p={2}
                          style={{
                            backgroundColor: themeStyle.primaryColor,
                            color: "white",
                            height: "30px",
                          }}
                          borderRadius={6}
                        >
                          <h3
                            style={{
                              marginTop: "16px",
                              fontSize: "15px",
                            }}
                          >
                            STUDENT REQUESTS
                          </h3>
                        </Button>
                      ) : (
                        <Button
                          fullWidth
                          value="LEAVEREQUESTS"
                          onClick={handlePageSelect}
                          p={2}
                          style={{
                            backgroundColor: themeStyle.primaryColorLight,
                            color: "white",
                            height: "30px",
                          }}
                          borderRadius={6}
                        >
                          <h3
                            style={{
                              marginTop: "16px",
                              fontSize: "15px",
                              color: themeStyle.secondaryColor,
                            }}
                          >
                            LEAVE REQUESTS
                          </h3>
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                }
              />
              <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open3}
                onClose={() => setOpen(false)}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={open3}>
                  <div
                    style={{
                      borderRadius: "15px",
                      position: "absolute",
                      top: "50%",
                      backgroundColor: "white",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: 400,
                      padding: "20px",
                    }}
                  >
                    {fileData()}
                  </div>
                </Fade>
              </Modal>
              <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open2}
                onClose={() => setOpen2(false)}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={open2}>
                  <div
                    style={{
                      borderRadius: "15px",
                      position: "absolute",
                      top: "50%",
                      backgroundColor: "white",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: 400,
                      padding: "20px",
                    }}
                  >
                    <div style={{ marginTop: "-25px" }}>
                      <div
                        style={{
                          marginTop: "20px",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <h3>Delete this item?</h3>
                        <IconButton size="small">
                          <CloseIcon
                            onClick={() => setOpen2(false)}
                            style={{ color: themeStyle.primaryColor }}
                          />
                        </IconButton>
                      </div>

                      <span>
                        This action cannot be reversed. It will be deleted
                        forever.
                      </span>
                      <br></br>
                      <br></br>
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Button
                          onClick={() => deleteItem()}
                          style={{
                            height: "30px",
                            backgroundColor: themeStyle.primaryColor,
                          }}
                          variant="contained"
                        >
                          Yes
                        </Button>
                        <Button
                          style={{
                            height: "30px",
                            marginLeft: "10px",
                            backgroundColor: themeStyle.primaryColor,
                          }}
                          variant="contained"
                          onClick={() => setOpen2(false)}
                        >
                          No
                        </Button>
                      </div>
                    </div>
                  </div>
                </Fade>
              </Modal>
              <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={() => setOpen(false)}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={open}>
                  <div
                    style={{
                      borderRadius: "15px",
                      position: "absolute",
                      top: "50%",
                      backgroundColor: "white",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: 400,
                      padding: "20px",
                    }}
                  >
                    <div style={{ marginTop: "-25px" }}>
                      <div
                        style={{
                          marginTop: "20px",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <h3>Approve this leave request?</h3>
                        <IconButton size="small">
                          <CloseIcon
                            onClick={() => setOpen(false)}
                            style={{ color: themeStyle.primaryColor }}
                          />
                        </IconButton>
                      </div>

                      <span>This action cannot be reversed.</span>
                      <br></br>
                      <br></br>
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Button
                          onClick={() => approveLeave(true)}
                          style={{ height: "30px" }}
                          variant="contained"
                        >
                          Approve
                        </Button>
                        <Button
                          style={{ height: "30px", marginLeft: "10px" }}
                          variant="contained"
                          onClick={() => approveLeave(false)}
                        >
                          Reject
                        </Button>
                      </div>
                    </div>
                  </div>
                </Fade>
              </Modal>

              <div
                style={{
                  borderRadius: "15px",
                  margin: "65px 15px 20px 85px",
                  backgroundColor: "white",
                }}
              >
                {getPageContent()}{" "}
              </div>
            </Fragment>
          );
        }
      } else {
        dispatch({
          type: "AUTH_ERROR",
        });
        dispatch({ type: "AUTH_ERROR" });
      }
    } else {
      dispatch({ type: "AUTH_ERROR" });
    }
  } else {
    return (
      <div
        style={{
          borderRadius: "15px",
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "white",
          marginTop: "46vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
}

export default LeaveRequestsTeacher;
